// src/components/BulkOperations/BulkProgressBar.js
import React from "react";
import PropTypes from "prop-types";

/**
 * BulkProgressBar - Progress bar with stats for bulk operations
 *
 * Displays progress percentage, timer, and status counts
 */
const BulkProgressBar = ({
  progress,
  elapsedTime,
  label,
  statusCounts,
  isComplete,
  isDeviceProgress = false,
}) => {
  const formatTime = (ms) => {
    const seconds = Math.floor(ms / 1000);
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  return (
    <div className="progress-section">
      <div className="progress-bar-container">
        <div
          className={`progress-bar-fill ${
            isDeviceProgress ? "device-progress" : ""
          }`}
          style={{ width: `${progress}%` }}
        />
        <span className="progress-bar-label">{label}</span>
      </div>

      <div className="progress-stats">
        <div className="progress-left">
          <span className="progress-percentage">{progress}% Complete</span>
          <span
            className={`progress-timer ${isComplete ? "timer-complete" : ""}`}
          >
            <span className="timer-icon">⏱</span>
            <span className="timer-value">{formatTime(elapsedTime)}</span>
          </span>
        </div>

        <span className="progress-counts">
          <span className="stat resolved">
            {statusCounts.resolved} Resolved
          </span>
          <span className="stat pending">{statusCounts.pending} Pending</span>
          <span className="stat rejected">
            {statusCounts.rejected} Rejected
          </span>
        </span>
      </div>
    </div>
  );
};

BulkProgressBar.propTypes = {
  progress: PropTypes.number.isRequired,
  elapsedTime: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  statusCounts: PropTypes.shape({
    resolved: PropTypes.number.isRequired,
    pending: PropTypes.number.isRequired,
    rejected: PropTypes.number.isRequired,
  }).isRequired,
  isComplete: PropTypes.bool.isRequired,
  isDeviceProgress: PropTypes.bool,
};

export default BulkProgressBar;
